import { ProgramVerification } from '@trp/community/program-verification/interfaces';
import { ProgramOrSectionType } from '@trp/community/interfaces';
import { getSectionVerificationStatus } from './get-section-verification-status';

export interface VerifiedByInfo {
  verifiedBy: ProgramVerification['verifiedByUser'];
  verifiedAt: ProgramVerification['createdAt'];
}

export function getSectionVerifiedByInformation<
  T extends Pick<
    ProgramVerification,
    'property' | 'createdAt' | 'verifiedByUser' | 'programOrSectionType'
  > = ProgramVerification
>(
  section: ProgramOrSectionType,
  verifications: T[]
): VerifiedByInfo | null {
  const result = getSectionVerificationStatus(section, verifications);
  if (result.status === 'not-yet-verified') {
    return null;
  }

  const latestVerification = verifications
    .filter((v) => v.programOrSectionType === section)
    .reduce((prev, curr) => {
      if (!prev) {
        return curr;
      }
      if (new Date(prev.createdAt) < new Date(curr.createdAt)) {
        return curr;
      }
      return prev;
    }, null as T | null);

  if (!latestVerification) {
    return null;
  }

  return {
    verifiedBy: latestVerification.verifiedByUser,
    verifiedAt: latestVerification.createdAt,
  };
}
